import { render, staticRenderFns } from "./UpgradeToKYCDetail.vue?vue&type=template&id=3bd45e70&scoped=true&"
import script from "./UpgradeToKYCDetail.vue?vue&type=script&lang=js&"
export * from "./UpgradeToKYCDetail.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeToKYCDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UpgradeToKYCDetail.vue?vue&type=style&index=1&id=3bd45e70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd45e70",
  null
  
)

export default component.exports